export const FINALLY = 'Итого';
